import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SharedGridPage from "./SharedGridPage";
import AddEditTag from "src/components/tags/AddEditTag";

const ManageTag: FC = () => {
    const { t } = useTranslation();
    const { tagId } = useParams();

    return (
        <SharedGridPage
            title={tagId ? t('Tags.EditTag') : t('Tags.AddTag')}
            subComponent={<AddEditTag />}
        />
    );
};

export default ManageTag;
